module.exports = __webpack_public_path__ + "static/media/training-video-review.60d3d195.svg";